import { useState, Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// import { menuList } from "../../../../data/layout/SidebarMenuList";
import { MenuItem } from '../../../../types/Layout';
import { useAppSelector } from '../../../../reduxToolkit/hooks';
import SubMenu from './SubMenu';

const MenuList = ({ menuList }: { menuList: MenuItem[] }) => {
  const { pinedMenu } = useAppSelector((state) => state.layout);
  const [activeMenu, setActiveMenu] = useState<MenuItem[]>([]);
  const { t } = useTranslation();

  const shouldHideMenu = (mainMenu: MenuItem) =>
    (mainMenu.Items ?? []).every((it) => pinedMenu.includes(it.i18title ?? it.title));
  return (
    <>
      {menuList &&
        menuList.map((mainMenu, index) => (
          <Fragment key={index}>
            <li className={`sidebar-main-title ${shouldHideMenu(mainMenu) ? 'd-none' : ''}`}>
              <div>
                <h6>{t(`${mainMenu.title}`)}</h6>
              </div>
            </li>
            <SubMenu
              menu={mainMenu.Items}
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              level={0}
            />
          </Fragment>
        ))}
    </>
  );
};

export default MenuList;
